import React, { useState, useCallback, ReactElement } from 'react';
import * as css from './EvHybridInformation.module.scss';
import 'src/css/themes.scss';
import { IconSeeMore } from 'src/content/icons';
import { ConnectedVehicleRec } from 'src/models';
import { Dialog, ScrollBar } from '@framework-controls/core';
import { strings } from 'src/localization';

export interface IProps {
    connectedVehicle: ConnectedVehicleRec;
}

const EvHybridInformation = (props: IProps) => {
    const [infoOpen, setInfoOpen] = useState(false);
    const toggleInfo = useCallback(() => {
        setInfoOpen(!infoOpen);
    }, [infoOpen]);

    let plugTstamp: ReactElement | null = null;
    if (props.connectedVehicle.plugTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.plugStatus) {
            statusLit = props.connectedVehicle.plugStatus + ' ' + strings.AsOf;
        }
        plugTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.plugTstamp}</p>;
    }

    let plug: ReactElement | null = null;
    if (props.connectedVehicle.plugValue) {
        plug = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.PlugStatus}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.plugValue}
            </div>
            {plugTstamp}
        </span>;
    }

    let hybridTstamp: ReactElement | null = null;
    if (props.connectedVehicle.hybridTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.hybridStatus) {
            statusLit = props.connectedVehicle.hybridStatus + ' ' + strings.AsOf;
        }
        hybridTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.hybridTstamp}</p>;
    }

    let hybrid: ReactElement | null = null;
    if (props.connectedVehicle.hybridValue) {
        hybrid = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.HybridChargingMode}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.hybridValue}
            </div>
            {hybridTstamp}
        </span>;
    }

    let chargeTstamp: ReactElement | null = null;
    if (props.connectedVehicle.chargeTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.chargeStatus) {
            statusLit = props.connectedVehicle.chargeStatus + ' ' + strings.AsOf;
        }
        chargeTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.chargeTstamp}</p>;
    }

    let charge: ReactElement | null = null;
    if (props.connectedVehicle.chargeValue) {
        charge = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.ChargeStatus}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.chargeValue}
            </div>
            {chargeTstamp}
        </span>;
    }

    let chargeStartTstamp: ReactElement | null = null;
    if (props.connectedVehicle.chargeStartTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.chargeStartStatus) {
            statusLit = props.connectedVehicle.chargeStartStatus + ' ' + strings.AsOf;
        }
        chargeStartTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.chargeStartTstamp}</p>;
    }

    let chargeStart: ReactElement | null = null;
    if (props.connectedVehicle.chargeStartValue) {
        chargeStart = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.ChargeStartTime}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.chargeStartValue}
            </div>
            {chargeStartTstamp}
        </span>;
    }

    let chargeEndTstamp: ReactElement | null = null;
    if (props.connectedVehicle.chargeEndTstamp) {
        let statusLit = strings.DataAsOf;
        if (props.connectedVehicle.chargeEndStatus) {
            statusLit = props.connectedVehicle.chargeEndStatus + ' ' + strings.AsOf;
        }
        chargeEndTstamp = <p className={css.statusLit}>{statusLit + ' ' + props.connectedVehicle.chargeEndTstamp}</p>;
    }

    let chargeEnd: ReactElement | null = null;
    if (props.connectedVehicle.chargeEndValue) {
        chargeEnd = <span className={css.infoBlock}>
            <div className={css.infoLit}>
                {strings.ChargeEndTime}
            </div>
            <div className={css.infoData}>
                {props.connectedVehicle.chargeEndValue}
            </div>
            {chargeEndTstamp}
        </span>;
    }

    return (
        <div>
            <span className={css.header}>
                <div className={css.headerLit}>{strings.ViewEvHybridData}</div>
                <div className={css.icon}>
                    <IconSeeMore onClick={() => toggleInfo()} />
                </div>
            </span>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={infoOpen}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={strings.EvHybridInformation.toUpperCase()}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={() => toggleInfo()}
                onBackDropClick={() => toggleInfo()}
                width={'full'}
            >
                <ScrollBar scrollVertical>
                    <div className={css.infoRow}>
                        {plug}
                        {hybrid}
                        {charge}
                        {chargeStart}
                        {chargeEnd}
                    </div>
                </ScrollBar>
            </Dialog>
        </div>
    );
};

export default EvHybridInformation;